import useOrder from 'modules/order/state/order/use-order'
import useConfig from 'modules/config/state/use-config'
import TextPlaceloader from 'modules/ui/atoms/Loaders/TextPlaceloader'
import { getFrequencyLabel } from 'utils/functions/frequencyUtils'
import {
  LineItemLeft,
  LineItemRight,
  LineItemContainer,
  TotalLineItemContainer,
} from './donation-summary.styled'
import { formatCurrency } from 'utils/functions/currencyUtils'
import { useTranslation } from 'next-i18next'

type ProcessingFeesLineItemProps = {
  isLoading: boolean
  feeAmount: number
  isDCFChecked: boolean
  currency: string
}

const ProcessingFeesLineItem = ({
  isLoading,
  feeAmount,
  isDCFChecked,
  currency,
}: ProcessingFeesLineItemProps) => {
  const { t, i18n } = useTranslation()

  const feeString = formatCurrency(
    isDCFChecked ? feeAmount : 0,
    currency,
    i18n.language,
    undefined,
    true,
  )

  return (
    <LineItemContainer>
      <LineItemLeft>{t('donationSummary.processingFees', 'Processing Fees')}</LineItemLeft>
      <LineItemRight>
        {isLoading && <TextPlaceloader w={30} fs="14px" lh="20px" />}
        {!isLoading && <LineItemRight>{feeString}</LineItemRight>}
      </LineItemRight>
    </LineItemContainer>
  )
}

export default function DonationSummary() {
  const config = useConfig()
  const { t, i18n } = useTranslation()
  const order = useOrder()

  const frequency = order.frequency.value
  const initialAmount = order.amount.value

  // State to track and show loading indicator if it's calculating fees
  const isLoading = order.dcf.value.isLoading

  const isDCFEnabled = config.dcf.isEnabled
  const isDCFChecked = order.dcf.value.isChecked

  const feeAmount = order.dcf.value.fee

  const totalAmount = order.dcf.value.totalAmount

  const formattedInitialAmount =
    formatCurrency(initialAmount, order.currency.value, i18n.language) ||
    `${order.currency.symbol}${initialAmount}`

  const formattedTotalAmount =
    formatCurrency(totalAmount, order.currency.value, i18n.language) ||
    `${order.currency.symbol}${totalAmount}`

  return (
    <>
      <LineItemContainer>
        <LineItemLeft>
          {' '}
          {t('donationSummary.frequencyDonationLabel', '{{frequency}} Donation', {
            frequency: getFrequencyLabel(frequency).toLowerCase(),
          })}
        </LineItemLeft>
        <LineItemRight>{formattedInitialAmount}</LineItemRight>
      </LineItemContainer>

      {isDCFEnabled && (
        <ProcessingFeesLineItem
          isLoading={isLoading}
          feeAmount={feeAmount}
          isDCFChecked={isDCFChecked}
          currency={order.currency.value}
        />
      )}
      <TotalLineItemContainer>
        <LineItemLeft>{t('donationSummary.totalDueToday', 'Total due today')}</LineItemLeft>
        <LineItemRight>{formattedTotalAmount}</LineItemRight>
      </TotalLineItemContainer>
    </>
  )
}
